export const CreateRequestFormDefaultValue = () => {
  return {
    fields: [{}],
  };
};

export default CreateRequestFormDefaultValue;
